export const jobTypesSk = {
  jobTypes: {
    // Database keys (snake_case)
    'full_time': 'Plný úväzok',
    'part_time': 'Polovičný úväzok',
    'half_time': 'Polovičný úväzok',
    'freelance': 'Freelance',
    'internship': 'Stáž',
    'contract': 'Zmluvný',
    'temporary': 'Dočasný',
    'seasonal': 'Sezónny',
    // Legacy display names (for backward compatibility)
    'Half Time': 'Polovičný úväzok',
    'Full Time': 'Plný úväzok',
    'Freelance': 'Freelance',
    'Internship': 'Stáž'
  }
};